const getFullLanguageName = (lang: string) => {
  switch (lang) {
    case "en":
      return "English";
    case "sv":
      return "Swedish";
    case "no":
      return "Norwegian";
    case "fi":
      return "Finnish";
    default:
      return "";
  }
};

export default getFullLanguageName;
